import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { filter } from 'lodash';

export interface UserGroupInterface {
  group: number;
  id: number;
  is_default: number;
  user: number;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-work-shift-role-popover',
  templateUrl: './work-shift-role-popover.component.html',
  styleUrls: ['./work-shift-role-popover.component.scss'],
  standalone: false,
})
export class WorkShiftRolePopoverComponent implements OnInit {
  public isShowCIPopover: boolean;

  @Input() userGroups: UserGroupInterface[];

  constructor() {}

  ngOnInit() {
    let defaultGroup = filter(this.userGroups, (group) => group.is_default === 1);

    if (this.userGroups && this.userGroups.length > 1 && defaultGroup.length) {
      this.isShowCIPopover = defaultGroup[0]['group'] !== 4;
    } else {
      this.isShowCIPopover = false;
    }
  }
}
